import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";

@Injectable()
export class AuthHttp {

    public authKey = "zefiro.pocket.app.auth";  // ToDo: spostare nel model-locator!?
    public authData: any = null;

    constructor(private http: Http) { }

    get(url, opts = {}) {

        this.configureAuth(opts);
        return this.http.get(url, opts).share();
    }

    post(url, data, opts = {}) {
        this.configureAuth(opts);
        return this.http.post(url, data, opts).share();
    }

    put(url, data, opts = {}) {
        this.configureAuth(opts);
        return this.http.put(url, data, opts).share();
    }

    delete(url, opts = {}) {
        this.configureAuth(opts);
        return this.http.delete(url, opts).share();
    }

    configureAuth(opts: any) {

        if (!this.authData) {
            let obj = localStorage.getItem(this.authKey);

            if (null != obj) {
                let auth = JSON.parse(obj);

                if (auth)
                    this.authData = auth;
            }
        }

        if (this.authData && this.authData.access_token) {
            if (null == opts.headers) {
                opts.headers = new Headers();
            }
            opts.headers.set("Authorization", `Bearer ${this.authData.access_token}`);
        }
 

        /* var i = localStorage.getItem(this.authKey);

        if (null != i) {
            var auth = JSON.parse(i);
            
            if (null != auth.access_token) {
                if (null == opts.headers) {
                    opts.headers = new Headers();
                }
                opts.headers.set("Authorization", `Bearer ${auth.access_token}`);
            }
        } */
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.http.ts